import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import * as SlideSelectors from "Data/slides/SlideSelectors";
import Middle from "Components/Middle";
import CloseButton from "../components/CloseButton";
import { Player } from 'patchwork-player';

class PlayerController extends React.Component
{
    render()
    {
        const orderedSlides = _.orderBy(this.props.slides, [slide => slide.position], ['asc']);

        // NEW:: Embed the Elements into the slides
        const orderedSlidesWithElements = _.map(orderedSlides, slide => ({
            ...slide,
            elements: this.props.getElements(slide.id)
        }));

        return <div className="relative h-full w-full overflow-hidden flex justify-center" style={{background: 'radial-gradient(ellipse at center, #444444 0%,#222222 100%)'}}>
            <CloseButton />
            {
                <Middle>
                    <Player slides={orderedSlidesWithElements} />
                </Middle>
            }
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => ({
    slides: SlideSelectors.filterByStoryId(state, ownProps.storyId),
    getElements: slideId => {
        // map over the elements
        const elements = _.map(state.elements, element => {

            // if we have an image element
            if (element.type === 'image') {

                // find the media item it uses
                const media = _.find(state.media, ['id', element.data.media_id])

                return {
                    ...element,
                    data: {
                        ...element.data,
                        src: media ? media.filename : null              // and add the filename as element.data.src
                    }
                }
            }

            return element;
        });
        return _.filter(elements, ['slide_id', slideId])
    }
});

export default connect(mapStateToProps)(PlayerController);